import { IResetPasswordUserData } from '../../domain/models/IResetPasswordUserData';
import { useHashMatch } from '../../../../shared/router/hash/useHashMatch';

const USER_DATA_HASH_PATTERN = '#code=(:code)&user=(:username)';

export function useUserDataFromUrl(): IResetPasswordUserData | undefined {
	const { matches } = useHashMatch<IResetPasswordUserData>(
		USER_DATA_HASH_PATTERN,
	);

	return matches;
}
